import React from "react";
import { Row, Col, Spin } from "antd";
import { formatMoneyValue } from "utils/utils";
import { getSourceAccountCurrency, getPayNowQrImage } from "../../../api/api";
import { displayGenericError } from "../../../common/notifications";
import FieldValueVerticalCell from "components/general/FieldValueVerticalCell";

import "./DbsPayNowInstructionsPanel.css";
import { getSearchParamValueByName } from "../../../utils/utils";

export default class DbsPayNowInstructionsPanel extends React.Component {
  state = {
    sourceAccountCurrency: {},
    qrImageUrl: null,
  }
  componentDidMount() {
    const { payment } = this.props;
    this.orderId = getSearchParamValueByName("orderId");
    this.order_id = getSearchParamValueByName("order_id");
    if(!this.order_id){
      this.order_id = this.props.order.id;
    }


    getSourceAccountCurrency(payment.sourceValue.currency).then(response => {
      this.setState({ sourceAccountCurrency: response })
    }).catch(error => {
      displayGenericError(error);
    });
    getPayNowQrImage(this.order_id).then(url => {
      this.setState({ qrImageUrl: url });
    }).catch(error => {
      displayGenericError(error);
    });
  }
  componentWillUnmount() {
    if (this.state.qrImageUrl) {
      URL.revokeObjectURL(this.state.qrImageUrl);
    }
  }
  render() {
    const { sourceAccountCurrency, qrImageUrl } = this.state;
    return (
      <>
        <p>Use the instructions below to make your "PAYNOW" payment. Your Reference ID : <b>{this.props.currentCustomer.referenceNumber}</b></p>
        <span className="bp-notice">
          We will only process your order if the payment to Brdgx is from a
          same-name account.
        </span>
        <div className="bp-inner-panel bp-inner-padding-lg">
          <Row gutter={32} id="paynow-row">
            <Col md={12} xs={24} className="paynow-col paynow-col-qr">
              <p className="paynow-col-title">Scan QR code with compatible banking app</p>
              {qrImageUrl ? (
                <img
                  id="dbsPayNowQrcode"
                  className="dbs-paynow-qrcode"
                  src={qrImageUrl}
                  alt="PayNow QR code"
                />
              ) : (
                <Spin className="dbs-paynow-qrcode" />
              )}
            </Col>
            <Col md={12} xs={24} className="paynow-col paynow-col-details">
              <p className="paynow-col-title">Or manually enter these details into your banking app</p>
              <FieldValueVerticalCell
                className="paynow-detail-cell"
                title="Unique Entity Number (UEN)"
                value={sourceAccountCurrency.uen}
              />
              <FieldValueVerticalCell
                className="paynow-detail-cell"
                title="Reference"
                value={this.props.currentCustomer.referenceNumber}
              />
              <FieldValueVerticalCell
                className="paynow-detail-cell"
                title="Amount"
                value={formatMoneyValue(this.props.payment.sourceValue)}
              />
            </Col>
          </Row>
        </div>
      </>
    );
  }
}
